module.exports = __webpack_public_path__ + "img/3.ce1f98e9.png";